import { render, staticRenderFns } from "./RelatorioAssinaturas.vue?vue&type=template&id=659e9815"
import script from "./RelatorioAssinaturas.vue?vue&type=script&lang=js"
export * from "./RelatorioAssinaturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports